var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuzz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "13px",
    viewBox: "0 0 23 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.59223178e-11%",
    y1: "49.9968251%",
    x2: "99.8761433%",
    y2: "49.9968251%",
    id: "buzz_svg__buzz_svg__linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98D00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98B00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "273252%",
    y1: "1450950%",
    x2: "274485%",
    y2: "1450950%",
    id: "buzz_svg__buzz_svg__linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98D00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98B00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2682%",
    y1: "30031%",
    x2: "3795%",
    y2: "30031%",
    id: "buzz_svg__buzz_svg__linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98D00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98B00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "3949%",
    y1: "30031%",
    x2: "5062%",
    y2: "30031%",
    id: "buzz_svg__buzz_svg__linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98D00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98B00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "31610%",
    x2: "5067%",
    y2: "31610%",
    id: "buzz_svg__buzz_svg__linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98D00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98B00",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "buzz_svg__buzz_svg__02-Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buzz_svg__buzz_svg__01-1-Home_v2",
    transform: "translate(-11.000000, -293.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buzz_svg__buzz_svg__Group-10",
    transform: "translate(-12.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buzz_svg__buzz_svg__Group-8",
    transform: "translate(23.000000, 293.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.96115891e-13,8.99615505 L7.96115891e-13,0.00780617827 L2.5822491,0.00780617827 C3.17841134,-0.0422140326 3.77002367,0.149559628 4.23226251,0.542665062 C4.62587386,0.991131612 4.82237287,1.58851225 4.7749725,2.19256874 C4.7991351,2.66927388 4.70733569,3.14463203 4.5079942,3.57504297 C4.34542223,3.89104306 4.04869534,4.10934634 3.70705931,4.16429428 C4.0966564,4.21586767 4.44350072,4.44536149 4.65242508,4.78980722 C4.89610442,5.22181372 5.01319532,5.7178964 4.98943047,6.21760847 C5.05032721,6.96741904 4.84662087,7.71466283 4.41608364,8.32078239 C3.94269203,8.80451436 3.28868561,9.0496077 2.62601604,8.99162235 L0,8.99162235 L7.96115891e-13,8.99615505 Z M1.56247954,3.65663161 L2.10081283,3.65663161 C2.40478799,3.69217758 2.70895064,3.591574 2.93676127,3.38013677 C3.1217589,3.0798608 3.20349068,2.72371238 3.16872602,2.36934413 C3.25278213,2.04563202 3.16283752,1.70009599 2.93306169,1.46400345 C2.70328585,1.22791092 2.36894208,1.13749457 2.0570459,1.22710313 L1.56247954,1.22710313 L1.56247954,3.65663161 L1.56247954,3.65663161 Z M1.56247954,7.73606378 L2.22336025,7.73606378 C2.54642365,7.77253412 2.86810866,7.65593107 3.09869892,7.41877461 C3.29797829,7.08885188 3.38716069,6.70029724 3.35254714,6.31279522 C3.39293655,5.91460956 3.29519616,5.51453226 3.07681546,5.18415233 C2.78672868,4.941378 2.41426072,4.83023121 2.04391582,4.87592856 L1.56247954,4.87592856 L1.56247954,7.73606378 L1.56247954,7.73606378 Z",
    id: "buzz_svg__buzz_svg__Shape",
    fill: "url(#buzz_svg__buzz_svg__linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0.0132989984 L7.77958657,0.0132989984 L7.77958657,5.9357863 C7.73384867,6.40926703 7.82736087,6.88533287 8.05039322,7.31444914 C8.28231678,7.58102893 8.64824491,7.71856165 9.01755983,7.67795509 C9.38752656,7.72307454 9.75579457,7.58466239 9.98472644,7.31444914 C10.2021038,6.8775363 10.2920811,6.39639096 10.2458614,5.9180543 L10.2458614,0.0177319979 L11.996433,0.0177319979 L11.996433,6.06434329 C12.0120456,6.49807732 11.9763749,6.93208591 11.8900447,7.35877913 C11.8244755,7.61853022 11.7009917,7.86303661 11.5273572,8.07692505 C11.2648667,8.3888529 10.9134128,8.62818451 10.5118322,8.76847297 C10.0325852,8.93172092 9.52384844,9.00994873 9.012724,8.99898894 C7.92304961,8.99898894 7.15415216,8.78177196 6.70603163,8.34733802 C6.2579111,7.91290407 6.03385083,7.15338349 6.03385083,6.06877628 L6.03385083,0 L6,0.0132989984 Z",
    id: "buzz_svg__buzz_svg__Shape",
    fill: "url(#buzz_svg__buzz_svg__linearGradient-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "buzz_svg__buzz_svg__Shape",
    fill: "url(#buzz_svg__buzz_svg__linearGradient-3)",
    points: "12 9 12 7.4795764 15.1132075 1.40242057 12.1572327 1.40242057 12.1572327 0 16.8697215 0 16.8697215 1.38426626 13.7969452 7.4795764 17 7.4795764 17 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "buzz_svg__buzz_svg__Shape",
    fill: "url(#buzz_svg__buzz_svg__linearGradient-4)",
    points: "18 9 18 7.4795764 21.1132075 1.40242057 18.1527403 1.40242057 18.1527403 0 22.8652291 0 22.8652291 1.38426626 19.7924528 7.4795764 23 7.4795764 23 9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "buzz_svg__buzz_svg__Rectangle-path",
    fill: "url(#buzz_svg__buzz_svg__linearGradient-5)",
    x: 0,
    y: 10,
    width: 23,
    height: 3
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuzz);
export default __webpack_public_path__ + "static/media/buzz.0b9fa7d9c4e0e6e0dd80720ff9df935f.svg";
export { ForwardRef as ReactComponent };